import { render, staticRenderFns } from "./ModalPassword.vue?vue&type=template&id=1420493d&scoped=true"
import script from "./ModalPassword.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalPassword.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ModalPassword.vue?vue&type=style&index=0&id=1420493d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1420493d",
  null
  
)

export default component.exports